import React, { useEffect, useState, useRef } from 'react';
import { reportsDialogCss } from './ReportsDialogCss';
import { withRouter, useHistory } from 'react-router-dom';
import {
    DialogTitle, DialogContent, DialogActions, Dialog
} from '@material-ui/core';
import { Document, Page, pdfjs } from 'react-pdf';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import ImageIcon from '../ImageIcon';
import { connect } from "react-redux";
import Button from '@material-ui/core/Button';
import FilterComponent from '../FilterComponent/FilterComponent';
import TripStatusFilter from '../FilterComponent/TripStatusFIlter';
import PaymentStatusFIlter from '../FilterComponent/PaymentStatusFIlter';
import DateFilter from '../FilterComponent/DateFilter';
import CustomDateFilterDialog from '../FilterComponent/CustomDateFilter';
import PartySupplierFilter from '../FilterComponent/PartySupplierFilter';
import DocumentBookPdfFilter from '../FilterComponent/DocumentBookPdfFilter';
import * as logger from "../../../logger";
import { getAllPnlMonths, getPNLPerMonth, getAllParties, getSinglePartyPDFReport, getAllVendors, getSingleVendorPDFReport } from '../../../store/actions/homeActionCreator';
import { vehicleTripPNLMonthlyList, vehicleTripPNLMonthlyPDF, getVehicleDocumentPDF, vehicleMonthlyPnlReportPDF, vehcileMonthlyPnlReportV2, vehcileMonthlyPnlReportPdf, truckIncomeExcel, getSingleDriverKhatPdf } from '../../../store/actions/vehicleActionCreator';
import { getTripPdf, getInvoicePdf } from '../../../store/actions/tripActionCreator';
import { profitLossPdfV2, transactionReport, transactionReportDownload, supplierPassbookReport, supplierPassbookReportDownload, downloadProfitLossPdfV2, pnlReportExcel, supplierLegerPdfV2, supplierLegerPdfDownloadV2, partyLegerPdfV2, partyLegerPdfDownloadV2, partyBalanceExcel, supplierBalanceExcel, getSingleShopKhataPdf, updateChatView } from '../../../store/actions/userActionCreators';
import { getTripStartDateFilterValues, getRequestTimeInMillis, getDateFilterValueForMonthlyBalance, getEpochForSpecificMonth, getMilliDatePickerDateInStringDDMMMYYYY } from "../../../utils/utils";
import {
    TRIP_FILTER_STATUS,
    TRIP_FILTER_STATUS_MAPPING,
} from "../../../store/constants";
import { trackDwebEvent } from '../../analytics';
import { SizeMe } from 'react-sizeme';
import { ExcelIconBlack, PdfIconWhite } from '../../../components/icons';

const ReportsDialog = ({

    // Using this variable incase many default values need to be passed from components .
    defaultValueObject,
    // *********************

    open,
    user,
    vehicle,
    location,
    onClose,
    name,
    fromDocumentBook,
    fromSinglePartyPage,
    fromSingleSupplierPage,
    dispatchGetTransactionPdf,
    dispatchGetTransactionPdfDownload,
}) => {

    // ************************************* State variables *************************************
    const focusPdf = React.createRef();

    var dateFilterValues = getTripStartDateFilterValues()

    const [dialogOpen, setDialogOpen] = useState(open);
    const [dateValue, setDateValue] = useState("");
    const [pdfWidth, setPdfWidth] = useState(document.body.clientWidth - 35);
    const [numPages, setNumPages] = useState(null);
    const [reportData, setReportData] = useState({});
    const [paymentStatus, setPaymentStatus] = useState("all");
    const [dateFilterValue, setDateFilterValue] = useState("ALL_MONTHS");
    const [customer, setCustomer] = useState([]);
    const [changeDataFlag, setChangeDataFlag] = useState(false);
    const [startDateRange, setStartDateRange] = useState({});
    const [showPaymentStatusFilter, setShowPaymentStatusFilter] = useState((fromSinglePartyPage || fromSingleSupplierPage) ? false : true);
    const [documentFilterKeyValue, setDocumentFilterKeyValue] = useState("");
    const [customFilter, setCustomFilter] = useState(false);
    const [customFilterValue, setCustomFilterValue] = useState({});
    const [docCount, setDocCount] = useState(1);
    // *****************************************************


    // *********************************************** Setting Default Values if required ***********************************************
    useEffect(() => {

        if (!changeDataFlag) {
            if (defaultValueObject && defaultValueObject.tripStatusFilter) {
                setPaymentStatus(defaultValueObject.tripStatusFilter);
            } else if (defaultValueObject && defaultValueObject.paymentStatusFilter) {
                setPaymentStatus(defaultValueObject.paymentStatusFilter)
            }

            if (defaultValueObject && defaultValueObject.dateFilterStatus) {
                setDateFilterValue(defaultValueObject.dateFilterStatus);
            }

            if (defaultValueObject && defaultValueObject.customDateRange) {
                setCustomFilterValue(defaultValueObject.customDateRange);
            }
        }

    }, [defaultValueObject])
    //  *******************************************
    const fetchTransactionPdf = (requestData) => {
        dispatchGetTransactionPdf(
            requestData,
            (data) => {
                setShowPaymentStatusFilter(true);
                if (data && data.status && data.status.code == 200) {
                    let response = data.response;
                    if (response.pdfId) {
                        requestData.pdfId = response.pdfId;
                    }
                    dispatchGetTransactionPdfDownload(requestData, (res) => {
                        if (res && res.status && res.status.code == 200) {
                            logger.log("Reports Dialog Dweb", "Get Single Party PDF Successfull");
                            //setPaymentStatus(data.response && data.response.defaultFilterApplied ? "all" : "all");
                            setReportData(res.response)
                        }
                    }, () => {

                    })
                }
            },
            () => {
                logger.log("Reports Dialog Dweb", "Get Single Party PDF Failed");
                setShowPaymentStatusFilter(true);
                //setPaymentStatus("all");
            }
        )
    }

    // ************************************************ Calling initial APIs required for respective flows ************************************************
    useEffect(() => {

        if (name == "Transaction Report") {
            let requestData = {
                customer: [],
                fleetOwnerId: user.userInfo && user.userInfo.entityId ? user.userInfo.entityId : "",
                getCustomersOnlyWithBalance: false,
                getTripsOnlyWithBalance: false,
                startDateRange: dateFilterValues[dateFilterValue]["startDateRange"],
                status: paymentStatus,
                defaultStatus: true
            }

            if (defaultValueObject) {
                if (defaultValueObject.dateFilterStatus) {
                    requestData.startDateRange = dateFilterValues[defaultValueObject.dateFilterStatus]["startDateRange"];
                }
                if (defaultValueObject.paymentStatusFilter) {
                    requestData.status = defaultValueObject.paymentStatusFilter;
                }
                if (defaultValueObject.customDateRange) {
                    requestData.startDateRange = {
                        startTimeEpoch: defaultValueObject.customDateRange.startTimeEpoch ? defaultValueObject.customDateRange.startTimeEpoch : "",
                        endTimeEpoch: defaultValueObject.customDateRange.endTimeEpoch ? defaultValueObject.customDateRange.endTimeEpoch : ""
                    }
                }
            }

            fetchTransactionPdf(requestData)
        }

    }, [open]);
    // *********************************************************************


    // ****************************** Setting PDF APIs response into state variable ******************************
    useEffect(() => {

        if (focusPdf.current) {
            focusPdf.current.focus();
        }


    }, [focusPdf, open, reportData]);
    // *******************************************************************


    // ***************************************** Recalling respective PDF APIs when PDF filters change *****************************************
    useEffect(() => {

        if ((name == "Transaction Report") && changeDataFlag) {
            let requestData = {
                customer: customer.length > 0 ? customer : [],
                fleetOwnerId: user.userInfo && user.userInfo.entityId ? user.userInfo.entityId : "",
                getCustomersOnlyWithBalance: false,
                getTripsOnlyWithBalance: false,
                startDateRange: dateFilterValues[dateFilterValue]["startDateRange"],
                status: paymentStatus
            }

            if (customFilterValue && customFilterValue.startTimeEpoch) {
                requestData.startDateRange = {
                    startTimeEpoch: customFilterValue.startTimeEpoch,
                    endTimeEpoch: customFilterValue.endTimeEpoch
                }
            }

            fetchTransactionPdf(requestData)

        }

    }, [paymentStatus, dateFilterValue, customFilterValue])
    // *****************************************


    // ***************************************** Assigning report dialog CSS to variable *****************************************
    const classes = reportsDialogCss();
    // *****************************************


    // **************************************** Triggered when report dialog closed ****************************************
    const handleClose = () => {
        setDialogOpen(false);
        onClose();
        setReportData({});
    }
    // *************************************************

    // const handleDatePDFFilterClickOpen = () => {
    //     setPdfFilterOpen(true);
    // }

    const handlePaymentStatus = (value) => {
        setPaymentStatus(value);
        setChangeDataFlag(true);
    }

    const handleDateValue = (dateValue) => {
        if (dateValue == "CUSTOM") {
            setCustomFilter(true);
        }
        else {
            setDateFilterValue(dateValue);
            setCustomFilter(false);
            setCustomFilterValue({});
        }
        setChangeDataFlag(true);
    }

    // pdf related settings
    function onDocumentLoadSuccess({ numPages: nextNumPages }) {
        let header = document.getElementsByTagName('header')[0];
        if (header) {
            setPdfWidth(header.clientWidth - 60);
        }
        setNumPages(nextNumPages);
        // setNumPages(3);
    }

    // ******************************************* Tracking Events when download button is clicked *******************************************
    const handleDownloadClick = () => {

    }
    // *******************************************

    const handleCustomFilterClose = () => {
        setCustomFilter(false);
    }

    const handleCustomFilterConfirm = (value) => {
        setDateFilterValue("CUSTOM");
        setCustomFilter(false);
        setCustomFilterValue(value);
    }


    pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;


    return (
        <>
            <Dialog fullWidth={true}
                maxWidth='xl'
                onClose={handleClose} disableEscapeKeyDown={true} disableBackdropClick={true} aria-labelledby="add-driver-dialog-title" open={dialogOpen} classes={{ paperScrollPaper: classes.paper1, paperWidthXl: fromDocumentBook ? classes.paperWidth : "" }} >
                <DialogTitle id="add-party-dialog-title" onClose={handleClose} className={classes.dialogTitleV1}>
                    <span>
                        <span className={classes.fwV1}>{name == "Monthly Balance Tab" ? "Export Party Ledger Report" : name}</span>
                    </span>
                    <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent className={classes.dialogContentV1}>

                    {(name == "Transaction Report") &&
                        <div className={classes.mtV1}>
                            {showPaymentStatusFilter &&
                                <span>
                                    <PaymentStatusFIlter status={handlePaymentStatus} fromReportsDialog={true} defaultPaymentStatusFilter={paymentStatus} />
                                </span>
                            }
                            <span className={classes.mlV1}>
                                <DateFilter dateValue={handleDateValue} fromReportsDialog={true} deafultValue={defaultValueObject && defaultValueObject.dateFilterStatus ? defaultValueObject.dateFilterStatus : ""} />
                            </span>
                        </div>
                    }
                    {reportData && reportData.s3Link ? (
                        <div className={classes.pdfContainer}>
                            <div className={classes.pdfSubContainer} tabIndex={0} ref={focusPdf} >
                                <SizeMe>
                                    {({ size }) => (
                                        <Document
                                            file={reportData && reportData.s3Link ? reportData.s3Link : null}
                                            onLoadSuccess={onDocumentLoadSuccess}
                                        >

                                            {/* <View style={styles.section}> */}
                                            {/* <Page pageNumber={pageNumber} width={pdfWidth} /> */}
                                            {
                                                Array.from(
                                                    new Array(numPages),
                                                    (el, index) => (
                                                        <Page
                                                            key={`page_${index + 1}`}
                                                            pageNumber={index + 1}
                                                            width={size.width ? size.width : 1}
                                                        />
                                                    ),
                                                )
                                            }
                                            {/* </View> */}

                                        </Document>
                                    )}
                                </SizeMe>
                            </div>
                        </div>
                    ) : (

                        <div className={classes.divV2}>
                            <ImageIcon />
                        </div>
                    )
                    }
                </DialogContent>
                <DialogActions className={classes.daV1}>
                    <Button variant="contained" className={classes.cancelButton} onClick={() => handleClose()} >
                        Close
                    </Button>
                    <a className={classes.anchorV1} href={reportData && reportData.s3Link ? reportData.s3Link : ""} target="_blank" download>
                        <Button className={classes.confirmV1} type="submit" variant="contained" onClick={() => handleDownloadClick()}>
                            Download
                        </Button>
                    </a>
                </DialogActions>
            </Dialog>

            {customFilter && <CustomDateFilterDialog open={customFilter} onClose={handleCustomFilterClose} onConfirm={handleCustomFilterConfirm} />}

        </>
    );

}

const mapStateToProps = (state) => ({ user: state.user, vehicle: state.vehicle, trip: state.trip });
const mapDispatchToProps = (dispatch) => ({
    dispatchGetTransactionPdf: (requestData, onSuccess, onError) => {
        dispatch(transactionReport(requestData, onSuccess, onError))
    },
    dispatchGetTransactionPdfDownload: (requestData, onSuccess, onError) => {
        dispatch(transactionReportDownload(requestData, onSuccess, onError))
    },
});
const ReportsDialogWithRouter = withRouter(ReportsDialog);
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ReportsDialogWithRouter);
